import { Button, Heading, TextField } from '@superops/ui-design-system';
import { getTranslatedText, Tag, withErrorBoundary } from '@nile/components';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { isEmpty, debounce } from 'lodash';

const PopupHeading = (props) => {
  const {
    filterText,
    setFilterText,
    intl,
    conditions,
    resetFilter,
    defaultListInfo,
    refreshTable
  } = props;
  const defaultSearchCondition = {
    ...defaultListInfo,
    condition: {
      joinOperator: 'AND',
      operands: [
        {
          attribute: 'name',
          operator: 'contains',
          value: ''
        }
      ]
    }
  };
  const filterSearch = (val) => {
    defaultSearchCondition.condition.operands[0].value = val;
    refreshTable('', defaultSearchCondition);
  };
  const debouncedFilter = useCallback(debounce(filterSearch, 1000), []);
  return (
    <div className="flex actr">
      <Heading>
        <FormattedMessage id="common.allassets" />
      </Heading>
      <div className="w250 ml20">
        <TextField
          value={filterText}
          placeholder={getTranslatedText(
            intl,
            'invoiceBuilder.catalogItems.search.placeholder'
          )}
          onChange={(val) => {
            setFilterText(val);
            debouncedFilter(val);
          }}
          autoComplete={false}
          prefix={<SVGIcon name="Search" />}
          suffix={
            filterText ? (
              <div className="position-relative z99">
                <Button
                  plain
                  monochrome
                  onClick={() => {
                    setFilterText(null);
                    filterSearch('');
                  }}
                  icon={<SVGIcon name="RejectedCircle" />}
                />
              </div>
            ) : null
          }
          size="small"
          variant="outline"
        />
      </div>
      {!isEmpty(conditions) && (
        <div onClick={resetFilter} className="reset-filter">
          <FormattedMessage id={`ticket.details.resetFilters`} />
        </div>
      )}
    </div>
  );
};
export default withErrorBoundary(PopupHeading);
